export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0033.1a6dfe90.webp";